import React from 'react';
import { ShieldCheck, IndianRupee, CreditCard, Headphones } from 'lucide-react';
import { features } from '../data/mock';

const iconMap = {
  ShieldCheck,
  IndianRupee,
  CreditCard,
  Headphones
};

const FeaturesSection = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-orange-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose <span className="text-orange-600">Gujarat Mobile?</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We're committed to providing you with the best mobile shopping experience in Gujarat
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const Icon = iconMap[feature.icon];
            return (
              <div
                key={index}
                className="group bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                  <Icon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Additional Trust Indicators */}
        <div className="mt-16 bg-white rounded-2xl shadow-lg p-8 md:p-12">
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div className="space-y-2">
              <div className="text-5xl font-bold text-orange-600">100%</div>
              <div className="text-gray-600 font-medium">Genuine Products</div>
            </div>
            <div className="space-y-2 border-l border-r border-gray-200">
              <div className="text-5xl font-bold text-orange-600">24/7</div>
              <div className="text-gray-600 font-medium">Customer Support</div>
            </div>
            <div className="space-y-2">
              <div className="text-5xl font-bold text-orange-600">0%</div>
              <div className="text-gray-600 font-medium">Down Payment EMI</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
